import SectionHeader from "./SectionHeader";
import { faqs } from "../data";
import {FaQuestion} from 'react-icons/fa';
import FAQ from "./FAQ";
const FAQs = () => {
  return (
    <section className="faqs">
        <div className="container faqs__contaniner">
            <SectionHeader icon={ < FaQuestion/>} title="Foires Aux Questions" />
            <div className="faqs__wrapper">
                {
                    faqs.map(({id,question,answer})=>{
                        return(
                            <FAQ key={id} question={question} answer={answer}/>

                            
                        )
                    })
                }
            </div>
        </div>
    </section>
  )
}

export default FAQs
